import { bfHaptic } from './BfHooks';
import { BfIconChevLeft, BfIconChevRight } from './BfIcons';
import { t } from '../../../i18n/uiText';

/**
 * Фиксированная панель «предыдущая / следующая глава» внизу экрана (BF).
 * Две прозрачные glass-капсулы по краям со стрелками.
 */
export default function BfChapterPager({
  prevTarget,
  nextTarget,
  onNavigate,
  hidden = false,
  inFlow = false,
}) {
  const go = (target) => {
    if (!target?.url) return;
    bfHaptic('light');
    onNavigate?.(target.url);
  };

  return (
    <nav
      className={`bf-chapter-pager${inFlow ? ' bf-chapter-pager--flow' : ''}`}
      data-hidden={hidden ? 'true' : 'false'}
      aria-label={`${t('previousChapter')}, ${t('nextChapter')}`}
    >
      <button
        type="button"
        className="bf-chapter-pager__pill bf-chapter-pager__pill--prev"
        disabled={!prevTarget}
        onClick={() => go(prevTarget)}
        aria-label={prevTarget ? `${t('previousChapter')}: ${prevTarget.label}` : t('previousChapter')}
      >
        <span className="bf-chapter-pager__arrow" aria-hidden="true">
          <BfIconChevLeft />
        </span>
        {prevTarget?.label ? (
          <span className="bf-chapter-pager__label">{prevTarget.label}</span>
        ) : null}
      </button>

      <button
        type="button"
        className="bf-chapter-pager__pill bf-chapter-pager__pill--next"
        disabled={!nextTarget}
        onClick={() => go(nextTarget)}
        aria-label={nextTarget ? `${t('nextChapter')}: ${nextTarget.label}` : t('nextChapter')}
      >
        {nextTarget?.label ? (
          <span className="bf-chapter-pager__label">{nextTarget.label}</span>
        ) : null}
        <span className="bf-chapter-pager__arrow" aria-hidden="true">
          <BfIconChevRight />
        </span>
      </button>
    </nav>
  );
}
